export const CERTIFICATION_ACTION = {
    INSPECTION_LIST : "INSPECTION_LIST",
    DOC_LIST : "DOC_LIST",
    SELECTED_DOC : "SELECTED_DOC"
}